import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = ["id"];
const _hoisted_2 = {
    key: 0,
    class: "!mb-10 font-sans !text-sm font-bold"
};
import { computed, defineAsyncComponent } from 'vue';
import { useMq } from 'vue3-mq';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MediaGalleryBlock',
    props: {
        useContainer: { type: Boolean, default: false },
        mediaItems: {},
        title: {},
        removeLowerMargin: { type: Boolean, default: true },
        columns: {},
        anchor: {}
    },
    setup(__props) {
        const screen = useMq();
        const useContainerForTitle = computed(() => {
            return props.useContainer || screen.mdMinus;
        });
        const useContainerForMultipleItems = computed(() => {
            return props.useContainer && ifMultipleItems.value && screen.lgPlus;
        });
        const useContainerOnSingleItem = computed(() => {
            return props.useContainer || screen.mdMinus;
        });
        const MediaGalleryCarousel = defineAsyncComponent(() => import('@molecules/MediaGalleryCarousel.vue'));
        const MediaItem = defineAsyncComponent(() => import('@molecules/MediaItem.vue'));
        const ifMultipleItems = computed(() => {
            return props.mediaItems.length > 1;
        });
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", {
                id: _ctx.anchor,
                class: _normalizeClass(["content-section block overflow-hidden lg:mx-0 lg:w-full", {
                        '-mx-4 lg:mx-auto': !_ctx.useContainer,
                        '!mb-0': _ctx.removeLowerMargin,
                    }]),
                "data-media-gallery-block": ""
            }, [
                _createElementVNode("div", {
                    class: _normalizeClass({
                        container: useContainerForTitle.value,
                    })
                }, [
                    (_ctx.title)
                        ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(_ctx.title), 1))
                        : _createCommentVNode("", true)
                ], 2),
                (ifMultipleItems.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass({
                            container: useContainerForMultipleItems.value,
                        })
                    }, [
                        _createVNode(_unref(MediaGalleryCarousel), {
                            columns: _ctx.columns,
                            "media-items": _ctx.mediaItems
                        }, null, 8, ["columns", "media-items"])
                    ], 2))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.mediaItems, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: item.id,
                            class: _normalizeClass({
                                container: useContainerOnSingleItem.value,
                            })
                        }, [
                            _createVNode(_unref(MediaItem), {
                                item: item,
                                isSingleItem: ""
                            }, null, 8, ["item"])
                        ], 2));
                    }), 128))
            ], 10, _hoisted_1));
        };
    }
});
